import styled from "styled-components";
const ModalSmallIconButton = styled.div`
  display: flex;
  margin-top: 22px;
`;

export { ModalSmallIconButton };


// WEBPACK FOOTER //
// src/modules/screens/settings/EmailProvider/styles.js